<div class="add-note-templates-dialog" [class.loading]="isProcessing">
  
  <div>
    <span>Remove Contact Confirmation</span>
  </div>

  <div style="margin: 20px">
    
    <div i18n="@@input-dialog-example.title">
      You are about to remove [{{ name }}] from notification [{{ globalId }} +
      {{ localId }}]. This action cannot be undone. Please provide a reason for
      this correction.
    </div>
    
    <br />

    <owc-select-dropdown
      [formControl]="reason"
      [label]="'Reason for Removal'"
      [limit]="3"
      [placeholder]="'Select an option'"
      visible
      required
      (valueChange)="typeListValue($event)"
    >
      <owc-list-item value="Incorrect Contact Data">Incorrect Contact Data</owc-list-item>
      <owc-list-item value="No Relevant Instrument at Facility">No Relevant Instrument at Facility</owc-list-item>
      <owc-list-item value="Contact No Longer with Company">Contact No Longer with Company</owc-list-item>
      <owc-list-item value="Distribution List Error">Distribution List Error</owc-list-item>
      <owc-list-item value="Other">Other</owc-list-item>
    </owc-select-dropdown>

  </div>

  <div class="import-dialog-content" style="margin: 20px">
    <owc-input
      [formControl]="addCommentFC"
      [cols]="30"
      [label]="placeholder"
      [rows]="3"
      [type]="'textarea'"
      [required]="flag"
      [disabled]="isProcessing"
    >
    </owc-input>
  </div>

  <div class="import-dialog-actions">
    <owc-button class="cancel-button" (click)="cancelClicked()">
      Cancel
    </owc-button>
    <owc-button [disabled]="isProcessing || reason.value.length==0 || (reason.value[0]==='Other' && addCommentFC.value==='')" color="primary" (click)="confirmDeletion()">
      {{ isProcessing ? 'Confirm Removal...' : 'Confirm Removal' }}
    </owc-button>
  </div>

</div>
